<template>
<div>
  <div class="contact_content clearfix" id="f-thanks">
    <div  class="contact_approved">
      <h3><span class="txt_break">お問い合わせいただきありがとうございました。</span></h3>
      <p>内容を確認させていただき担当から連絡ご連絡させていただきます。</p>
    </div>
  </div>
</div>
</template>
<script>
export default {
  name: 'Contact_approved'
}
</script>

<style>
  #f-thanks {
    display: none;
  }
  .contact_approved{
    border: 1px #b5b5b5 solid;
    border-radius: 3px;
    padding: 50px 30px;
  }
  .contact_approved h3{
    color: #1f30aa;
    text-align: center;
    font-size: 1.8em;
    padding-bottom: 40px;
  }
  .contact_approved p{
    font-size: 1.2em;
    padding: 10px 0;

  }
  .contact_approved span{
    color: #1f30aa;
  }
  @media screen and (max-width:768px) {
    .contact_approved h3{
      font-size: 1.4em;
      padding-bottom: 20px;
    }
    .contact_approved p{
      font-size: 1.0em;
    }
    span.txt_break{
      color: #1f30aa;
    }
    span.txt_break::before {
      content: "\A" ;
      white-space: pre ;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Contact_approved.vue